import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isMobileAny } from '../../../../utils/device';
import classes from './styles/index.module.scss';
import { useHeaderNavigationButtonsIsDarkTheme } from '../../utils';
import { Undo } from '../../../../components/Icons/Undo';
import RouteLink from '../../../../components/RouteLink';

export const ButtonBack = ({ size, href, className, disabled }) => {
	const isDarkTheme = useHeaderNavigationButtonsIsDarkTheme();
	const handleClick = () => {
		!href && window.history.back();
	};

	const componentClasses = classNames(
		{
			[classes.buttonBack_desktop]: !isMobileAny,
		},
		className,
	);

	return (
		<RouteLink
			href={href}
			className={componentClasses}
			link={!isDarkTheme}
			linkDark={isDarkTheme}
			rounded
			icon={<Undo />}
			size={size}
			styledButton
			onClick={handleClick}
			dataTestId='buttonBack'
			scroll={false}
			useDirty
			disabled={disabled}
		/>
	);
};

ButtonBack.propTypes = {
	size: PropTypes.string,
	href: PropTypes.string,
};

ButtonBack.defaultProps = {
	size: 'normal',
	href: '/navigation/back',
};
